import _fecthData from './fetchData';

export const fetchData = _fecthData;